import { render, staticRenderFns } from "./BinLocationsInfo.vue?vue&type=template&id=569d42c5&"
import script from "./BinLocationsInfo.vue?vue&type=script&lang=js&"
export * from "./BinLocationsInfo.vue?vue&type=script&lang=js&"
import style0 from "./BinLocationsInfo.vue?vue&type=style&index=0&id=569d42c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports